import { useState, useEffect } from 'react'
import { Modal, Select } from 'antd'

export function DimensionPickerModal({
  open,
  dimensions,
  defaultDimension,
  onConfirm,
  onCancel,
  isLoading,
}: {
  open: boolean
  dimensions: string[]
  defaultDimension?: string | null
  onConfirm: (dimension: string) => void
  onCancel: () => void
  isLoading: boolean
}) {
  const [selected, setSelected] = useState<string>(defaultDimension ?? dimensions[0] ?? '')
  const [searchValue, setSearchValue] = useState('')

  useEffect(() => {
    if (open) {
      setSelected(defaultDimension ?? dimensions[0] ?? '')
      setSearchValue('')
    }
  }, [open, defaultDimension, dimensions])

  return (
    <Modal
      title="Break down by…"
      open={open}
      onCancel={onCancel}
      onOk={() => selected && onConfirm(selected)}
      okText="Drill down"
      okButtonProps={{ disabled: !selected, loading: isLoading }}
      width={380}
    >
      <p className="text-sm text-gray-500 mb-3">Choose the dimension to break down this data point by:</p>
      <Select
        showSearch={{ searchValue, onSearch: setSearchValue }}
        value={searchValue ? undefined : (selected || undefined)}
        onChange={(val) => { setSelected(val); setSearchValue('') }}
        onOpenChange={(isOpen) => { if (!isOpen) setSearchValue('') }}
        options={dimensions.map((dim) => ({ value: dim, label: dim }))}
        placeholder={searchValue ? '' : 'Select a dimension'}
        style={{ width: '100%' }}
      />
    </Modal>
  )
}
